export default __webpack_public_path__ + "static/media/Attribute_Memory.3277d112.png";